import { createSlice } from "@reduxjs/toolkit";
import { getTranslate, getResetTranslate } from "../services/translate";

interface TranslateState {
  translatedContent: unknown | null;
  isPending: boolean;
  isError: boolean;
}

const initialState: TranslateState = {
  translatedContent: null,
  isPending: false,
  isError: false,
};

const translateSlice = createSlice({
  name: "translate",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getTranslate.pending, (state) => {
        state.isPending = true;
        state.isError = false;
        state.translatedContent = null;
      })
      .addCase(getTranslate.fulfilled, (state, action) => {
        state.isPending = false;
        state.isError = false;
        const payload = action.payload as { data?: unknown } | undefined;
        state.translatedContent = payload?.data ?? null;
      })
      .addCase(getTranslate.rejected, (state) => {
        state.isPending = false;
        state.isError = true;
        state.translatedContent = null;
      })
      .addCase(getResetTranslate, (state) => {
        state.translatedContent = null;
        state.isPending = false;
        state.isError = false;
      });
  },
});

export default translateSlice.reducer;
